export default {
  'Please select an output format': 'Selecciona un formato de salida',
}